import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-psa-form2-renewal',
  templateUrl: './view-psa-form2-renewal.component.html',
  styleUrls: ['./view-psa-form2-renewal.component.css']
})
export class ViewPsaForm2RenewalComponent implements OnInit {
title="Form-I: Form for verification of character and antecedents of All Employees";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/view-psa-form2-renewal/view-psa-form2-renewal.component.ts